import { ClientTypes } from '~/constants/clientTypes';

export type TDocument = {
  id?: string;
  docStatus: DocStatusEnum[];
  idDictWebDocument: number;
  idDoc: number;
  inn?: string;
  managerId?: string;
  nameDoc: string;
  pib?: string;
  idDocSign?: number | string | null;
  documentName?: string;
  deletionPermission?: DeletionPermissionEnum;
  tooltipText?: string;
  showInformer?: boolean;
  ownerId?: string;
};

export type TDocType = {
  id: number;
  name: string;
};

export type TDocumentsInStore = {
  documents: TDocuments;
  isCompleted: boolean;
  type: ClientTypes;
  registrationDate: string;
  readyForSigning: boolean | undefined;
  missingForms: string[] | undefined;
  missingDocuments: number[] | undefined;
};

export type TDocuments = {
  additionalDocuments: TDocument[];
  additionalMainDocuments: TDocument[];
  assetManagersDocuments: TDocument[];
  mainDocuments: TDocument[];
};

export enum DocStatusEnum {
  NOT_VERIFIED = 'NOT_VERIFIED',
  INVALID_SIGNATURE = 'INVALID_SIGNATURE',
  MISMATCHED_RNOKPP = 'MISMATCHED_RNOKPP',
  SUCCESS = 'SUCCESS',
  MISMATCHED_EDRPOU = 'MISMATCHED_EDRPOU',
  MISMATCHED_FULLNAME = 'MISMATCHED_FULLNAME',
  ORGANIZATION_ABSENT = 'ORGANIZATION_ABSENT',
  SIGNED_WITH_ELECTRONIC_STAMP = 'SIGNED_WITH_ELECTRONIC_STAMP',
}

export enum DeletionPermissionEnum {
  ALLOWED = 'ALLOWED',
  RESTRICTED = 'RESTRICTED',
  FORBIDDEN = 'FORBIDDEN',
}

export type UboOwnerMap = Record<string, string>;

export type TPerson = {
  firstName?: string;
  lastName?: string;
};
